import { snakeCase } from 'lodash-es'
import { unref } from 'vue'
import type VueRouter from 'vue-router'
import type { MaybeRef } from './usePolicyTypeSelection'

export type QueryParam = {
  [key: string]: string | number | boolean | null | undefined
}

// Utility type to enforce exactly one key-value pair
export type SingleQueryParam = {
  [K in keyof QueryParam]: Record<K, QueryParam[K]>
}[keyof QueryParam]

const stringifyQueryParam = (query: QueryParam) => {
  const stringified = Object.keys(query).map((key) => ({
    [`${snakeCase(key)}`]: snakeCase(`${query[key]}`),
  }))
  return Object.assign({}, ...stringified)
}

export const mapQueryParamsArray = (
  value: SingleQueryParam[] | SingleQueryParam
): SingleQueryParam[] => {
  const paramsArray = Array.isArray(value) ? value : [value]

  const filteredQueryParams = paramsArray.filter(
    (param) => param.keep !== false
  )

  return filteredQueryParams
}

export const setQueryParam = (
  param: MaybeRef<SingleQueryParam>,
  router: VueRouter
) => {
  const currentRoute = router.currentRoute

  const stringifiedParam = stringifyQueryParam(unref(param))

  const isNewQuery =
    JSON.stringify(currentRoute.query) !==
    JSON.stringify({ ...currentRoute.query, ...stringifiedParam })

  if (!isNewQuery) return

  router.replace({
    name: currentRoute.name || '',
    params: currentRoute.params,
    query: { ...currentRoute.query, ...stringifiedParam },
  })
}

export const getQueryParam = (key: string, router: VueRouter) => {
  const value = router.currentRoute.query[key] as string

  if (!value) return null

  if (isNaN(parseInt(value))) return value
  return parseInt(value)
}
